import { t } from 'i18next'

export const translate = (
  key: string,
  params?: { [x: string]: string }
): string => {
  return t<string>(key, params)
}
